import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import usePage from "../hooks/usePage";
import Menu from "../modules/public/menu/menu";
import useSharedData from "../hooks/useSharedData";
import Footer from "../modules/public/footer/footer";

function AgentPage() {
  const { pageImage, pageSliders, pageText } = usePage();

  const { isAuthed } = useSharedData();

  return (
    <>
      <Menu />

      {pageSliders}

      <Container className="content-style">
        {pageText}

        <div className="home-request-page mb-3">
          <Link to={isAuthed ? "/formagent" : "/register/agent"}>
            <div id="externalBotton">
              <p className="home-request-style">فرم درخواست اخذ نمایندگی</p>
            </div>
          </Link>
        </div>

        {pageImage}
      </Container>

      <Footer />
    </>
  );
}

export default AgentPage;
